module.exports = __webpack_public_path__ + "static/media/box.4da14870.svg";